'use strict';

import $ from 'jquery';
import React from 'react/addons';
import Fluxxor from 'fluxxor';
import cx from 'classnames';
/* eslint-disable new-cap */
var FluxMixin = Fluxxor.FluxMixin(React);
/* eslint-enable new-cap */

import RangePicker from 'react-daterange-picker';
import DatePickerPaginationArrow from 'ofs/components/datepicker/DatePickerPaginationArrow';

import {gettext} from 'ofs/i18n';
import moment from 'ofs/moment';
import Icon from 'ofs/components/common/Icon';

var messages = {
  SELECTED_LABEL: gettext("Your selected dates")
}


function noop() {}

var DatePicker = React.createClass({
  mixins: [FluxMixin],

  propTypes: {
    value: React.PropTypes.instanceOf(Date),
    name: React.PropTypes.string.isRequired,
    label: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    initialDate: React.PropTypes.shape({
      month: React.PropTypes.number,
      year: React.PropTypes.number
    }),
    stateDefinitions: React.PropTypes.object,
    dateStates: React.PropTypes.array,
    defaultState: React.PropTypes.string,
    onSelect: React.PropTypes.func
  },

  getDefaultProps() {
    return {
      onSelect: noop
    };
  },

  handleClick(event) {
    event.preventDefault();

    var flux = this.getFlux();
    var layers = flux.store('LayerStore').state;

    // if there is already a popover then don't add another one
    if (layers.filter((component) => component.type === 'popover').size > 0) {
      return;
    }

    var trigger = $(event.target).closest('.ofs-Input__Wrapper')[0];
    var triggerRightPos = trigger.getBoundingClientRect().right;
    var {value, initialDate, stateDefinitions, dateStates, defaultState} = this.props;

    if (value) {
      value = moment(value);
    }

    var initialMonth;
    var initialYear;

    if (initialDate) {
      initialMonth = initialDate.month;
      initialYear = initialDate.year;
    }

    var panelAttatchment = "top center";
    var targetAttachment = "bottom center";

    //safe tablet size
    var windowWidth = window.innerWidth;
    if (windowWidth > 640) {
      panelAttatchment = "top right";
      targetAttachment = "bottom right";
      if (triggerRightPos < (windowWidth / 2)) {
        panelAttatchment = "top left";
        targetAttachment = "bottom left";
      }
    }

    this.getFlux().actions.layers.addPopover(
      <RangePicker
        trigger={trigger}
        panelAttachment={panelAttatchment}
        targetAttachment={targetAttachment}

        stateDefinitions={stateDefinitions}
        dateStates={dateStates}
        defaultState={defaultState}
        selectedLabel={messages.SELECTED_LABEL}

        value={value}
        numberOfCalendars={1}
        selectionType="single"
        paginationArrowComponent={DatePickerPaginationArrow}
        minimumDate={new Date()}
        firstOfWeek={1}
        initialMonth={initialMonth}
        initialYear={initialYear}

        bemNamespace="ofs"
        bemBlock="DatePicker"

        onSelect={this.handleSelect}
        showLegend={true}
      />
    );
  },

  handleSelect(value, states) {
    // wait till next event loop
    setTimeout(() => {
      this.getFlux().actions.layers.remove();
      this.props.onSelect(value, states);
    }, 0);
  },

  render() {
    var {name, label, placeholder, value} = this.props;

    var displayValue;
    var formValue;

    if (value) {
      displayValue = moment(value).longDateFormat();
      formValue = moment(value).isoDateFormat();
    }

    var inputClasses = cx({
      'ofs-Input': true,
      'ofs-Input--date': true,
      'u-pointer': true
    });

    return (
      <div className="ofs-Form__Field">
        {label ? <label className="ofs-Form__Label">{label}</label> : null}

        <input type="hidden"
          name={name}
          value={formValue} />

        <div className="ofs-Input__Wrapper ignore-react-onclickoutside">
          <div className={inputClasses} onClick={this.handleClick}>
            {formValue ?
              <span className="value">{displayValue}</span> :
              <span className="ofs-Input__Placeholder">{placeholder}</span>}
          </div>
          <div className="ofs-Input__Icon" onClick={this.handleClick}>
            <Icon glyph="calendar" size="small" />
          </div>
        </div>
      </div>
    );
  }
});

export default DatePicker;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/daterange/DatePicker.jsx
 **/